import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline ,MDBDataTable,MDBCardTitle, MDBCardText, MDBTypography } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Progress   } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'
import Modalreward from './Modalreward';
import Modalrewardedit from './Modalrewardedit';
import Commentexlistexforshow from './expert/Commentexlistexforshow';




export default class Modalreportscorearticalpresent2 extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
              
                articletype:[],
                articletypegroup:[],
                Articlepass:[],
                Articlepassselect:[],
                articalmapforroom:[],
                id_room:'',
                roompresent_date:'',
                roompresent_details:'',

                id_roompresent:'', //id ห้องนำเสนอ
                id_send	:'',//idบทความ
                
                }

            
                this.handleSubmit = this.handleSubmit.bind(this);
                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
                this.gettypegroup = this.gettypegroup.bind(this);
                this.onChangedatesapa = this.onChangedatesapa.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.getArticleconnpayforadminpass = this.getArticleconnpayforadminpass.bind(this);
                this.handleChangeaetical = this.handleChangeaetical.bind(this);
                this.getroommapArticle = this.getroommapArticle.bind(this);
    }

        onChangedatesapa(value) {
            this.setState({ roompresent_date: value.target.value });
        }


                toggle = () => {
                this.setState({
                    modal: !this.state.modal
                });
                // this.props.selectatf();
                this.gettype();
                this.gettypegroup();
                this.getArticleconnpayforadminpass();
                this.getroommapArticle();

                    if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
                    this.setState({ send_status: '2'})
                    }

                }


                onClickradio = (nr) => () => {
                this.setState({
                    radio: nr,
                });

                };




            componentDidMount() {
            const id_roompresent = this.props.id_roompresent
                //   console.log(id_send);
                this.setState({ id_roompresent:this.props.id_roompresent})
             
            }



            gettype() {
                setTimeout(() => {
                api.get('registercon/selectroompresent')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ articletype: res.data})
                }) 
                }, 0);
            }

            gettypegroup() {
                setTimeout(() => {
                api.get('registercon/selecttpresentationtype')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ articletypegroup: res.data})
                }) 
                }, 0);
            }

            getArticleconnpayforadminpass() {
                setTimeout(() => {
                api.get('registercon/selectArticleconnpayforadminpass')
                .then(res => {
                    console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                    this.setState({ Articlepass: res.data})
                }) 
                }, 0);
            }

            getroommapArticle() {
              setTimeout(() => {
              api.get('registercon/selectreportscorearticalmapforroomex/'+this.props.id_roompresent)
              .then(res => {
                  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                  this.setState({ articalmapforroom: res.data})
              }) 
              }, 0);
            }


            handleChangetype(event) {  
                 // this.setState({id_room: event.target.value}); 
                  const result =  this.state.Articlepass.filter((word) => word.send_type === event.target.value);
                  this.setState({Articlepassselect:result}); 
                 }

            handleChangeaetical(event) {   this.setState({id_send: event.target.value});  }

            handleChangenamepresent(event) {   this.setState({roompresent_details: event.target.value});  }




 handleSubmit= (e) => {
  e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_roompresent", this.state.id_roompresent);
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("roommaparticle_status", '1');

     
     
     

    api.post("registercon/Insertroommaparticle",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
            console.warn(res);
            console.log("response: ", res)
                    if (res.data = '200') {

                        Swal.fire({
                            title: 'เพิ่มบทความสำเร็จ',
                            text: "Successfully registered",
                            icon: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'ตกลง'
                          }).then((result) => {
                            if (result.isConfirmed) {
                              // window.location.href = '/Superadminroompresent'
                              // Swal.fire(
                              //   'Deleted!',
                              //   'Your file has been deleted.',
                              //   'success'
                              // )
                             // this.props.list();
                              //this.toggle()
                              this.getroommapArticle();
                            }
                          })
                    
                    }else{
                    message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.id_room)
          console.log(this.state.roompresent_date)
          console.log(this.state.roompresent_details)
        

          const items = this.state.articletype.map((articletype, i) => (
            <option  value={articletype.id_room} >{articletype.name_room} ความจุ {articletype.num_room} คน</option>
          ));

          const itemsgroup = this.state.articletypegroup.map((articletypegroup, i) => (
            <option  value={articletypegroup.presentype_id} >{articletypegroup.presentype_name	}</option>
          ));

          const itemsartical = this.state.Articlepassselect.map((Articlepassselect, i) => (
            <option  value={Articlepassselect.id_send} >{Articlepassselect.name_article	}</option>
          ));


          const datast = {
            columns: [
              {
                label: 'ลำดับ',
                field: 'list',
                sort: 'list',
                width: 150
              },
              {
                label: 'ชื่อบทความ',
                field: 'name_expert',
                sort: 'name_expert',
                width: 150
              },
              {
                label: 'ชื่อผู้นำเสนอ',
                field: 'roompresent_date',
                sort: 'roompresent_date	',
                width: 150
              },
              {
                label: 'กลุ่มนำเสนอ',
                field: 'password_expert',
                sort: 'password_expert',
                width: 150
              },
              {
                label: 'รายงานคะแนนรวม',
                field: 'print',
                sort: 'print',
                width: 150
              },
              {
                label: 'รายงานคะแนนแยกผู้ทรงคุณวุฒิ',
                field: 'print3',
                sort: 'print3',
                width: 150
              },
            //   {
            //     label: 'เกียรติบัตร',
            //     field: 'print4',
            //     sort: 'print4',
            //     width: 150
            //   },
            //   {
            //     label: 'จัดการรางวัล',
            //     field: 'print2',
            //     sort: 'print2',
            //     width: 150
            //   },
            ],
      
      
            rows: [...this.state.articalmapforroom.map((data, i) => (
                
              {
                 list: <>{i+1}</>,
                 name_expert: <>{data.name_article}</>,
                 roompresent_date: <>{data.name_present}</>,
                 password_expert: <>{data.presentype_name}</>,
                 print: <div className='text-center'>{data.score} /300 คะแนน
                 <div style={{ width: 170 }}>
                
                 <Progress percent={ Math.round(data.score*100/300)} size="small" status="active" />
                    
               </div>
                  </div>,
                  print3: <><Commentexlistexforshow id_send={data.id_send} /></>,
                //  print3: <div className='text-center'>{data.name_reward !== null ?<> {data.name_reward}</>:<>ได้เข้าร่วม</>}</div>,
                //  print4: <div className='text-center'>เกียรติบัตร</div>,
                //  print2: <div className='text-center'>{data.name_reward !== null ?<> 
                //       <Modalrewardedit id_roompresent={this.props.id_roompresent} id_send={data.id_send} getroommapArticle={this.getroommapArticle} name_article={data.name_article} /> 
                //      </>:<>
                //       <Modalreward id_roompresent={this.props.id_roompresent} id_send={data.id_send} getroommapArticle={this.getroommapArticle} name_article={data.name_article}/>
                //      </>} 
                //      </div>,

                //  name_admin2: <><Modaleditexpert id_expert={data.id_expert} list={this.list} /></>,
                
              }
             ))]
        
            };
                const persons = <MDBDataTable
              // searching ={true}
                searchLabel="ค้นหา ชื่อเรื่อง"
                striped
                bordered
                small 
                entries={50}
                // entriesOptions={["10", "20"]}
                order={["age", "desc"]}
                data={datast}
                entriesLabel="จำนวนที่แสดง "
                infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                responsive 
                sortRows={['random']}
                theadColor="grey lighten-1"

                />


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle} size='sm'><MDBIcon icon="plus-square" />  รายงานคะแนนก่อนนำเสนอ</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="fluid">
              {/* <MDBModalHeader toggle={this.toggle}>นำเข้าบทความประจำห้อง {this.props.name_room} นำเสนอวันที่ {this.props.roompresent_date}</MDBModalHeader> */}
             <form 
                onSubmit={this.handleSubmit}
                 >
   
              <MDBModalBody>
              <img src={ban} className="rounded mx-auto " alt="aligment" />
              <div>
                    <br/>
           
                            {/* <div className="mb-2">
                            <label><strong>สาขาการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="สาขาวิทยาศาสตร์และเทคโนโลยี" >สาขาวิทยาศาสตร์และเทคโนโลยี</option>
                                         <option value="สาขามนุษยศาสตร์และสังคมศาสตร์" >สาขามนุษยศาสตร์และสังคมศาสตร์</option>
                            </select>
                            </div> */}
                         {/* <h5>นำเข้าบทความประจำห้อง</h5> */}
                         <MDBCardTitle>  <MDBTypography note noteColor='primary' noteTitle={'รายงานคะแนนก่อนนำเสนอ '} > </MDBTypography></MDBCardTitle>

                        

              </div>

              {persons}
              
              </MDBModalBody>
              <MDBModalFooter>
                 {/* <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn> */}
                 {/* <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn> */}
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
              </form>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
